import React, { useContext, useState } from "react";
import Header from "../../Components/Header/Header";
import { AppContext } from "../../Context/AppContext";

import "./Admins.css";

import * as Bs from "react-icons/bs";
import * as Ci from "react-icons/ci";
import * as Ri from "react-icons/ri";
import * as Ai from "react-icons/ai";
import * as Pi from "react-icons/pi";

import { Modal, Popconfirm, Switch } from "antd";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Utils from "../../Utils/Utils";

function Admins() {
  const navigate = useNavigate();
  const {
    admins,
    updateAdminDetails,
    adminsLoading,
    fetchAdmins,
    deleteAdmin,
  } = useContext(AppContext);
  const [acknowledge, setAcknowledge] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);

  const handleConfirmChange = async (admin) => {
    const alterNotificationSettings =
      admin.notifications === false ? true : false;

    const payload = {
      id: admin._id,
      notifications: alterNotificationSettings,
    };

    await updateAdminDetails(payload, {
      onSuccess: async () => {
        toast.success(
          `Notification settings updated successfully for ${
            admin?.email ?? "admin"
          }.`
        );
        await fetchAdmins();
      },
      onFailed: (error) => {
        console.error("Error updating admin details", error);
      },
    });
  };

  const deleteAdminProfile = async () => {
    if (!selectedAdmin) {
      toast.error("Admin ID is required to delete the profile.");
      return;
    }

    const payload = { id: selectedAdmin };

    await deleteAdmin(payload, {
      onSuccess: async () => {
        toast.success(`Admin profile deleted successfully.`);
        await fetchAdmins();
        setAcknowledge(false);
      },
      onFailed: (error) => {
        console.error("Error deleting admin profile", error);
      },
    });
  };

  return (
    <>
      <Toaster position="top-center" />
      <Modal
        open={acknowledge}
        onCancel={() => setAcknowledge(false)}
        footer={null}
        maskClosable={false}
      >
        <h5>Confirm Action</h5>
        <hr />
        <p className="aknowledge_text">
          Would you like to proceed and delete this admin profile?
        </p>
        <p className="aknowledge_text_sub">
          <i>
            ⚠️ Deleting this admin profile will remove their access and
            permissions.
          </i>
        </p>
        <br />
        <div className="d-flex justify-content-end gap-2">
          <button
            className="modal_btn py-2 confirm_btn"
            onClick={deleteAdminProfile}
            disabled={adminsLoading}
          >
            {adminsLoading ? (
              <div class="text-center">
                <div
                  class="spinner-border spinner-border-sm"
                  role="status"
                ></div>
              </div>
            ) : (
              "Confirm"
            )}
          </button>
          <button
            className="modal_btn py-2 cancel_btn"
            onClick={() => setAcknowledge(false)}
            disabled={adminsLoading}
          >
            Cancel
          </button>
        </div>
      </Modal>
      <div className="container-fluid background">
        <Header />
        <div className="mains">
          <div className="table-title data">
            <div className="flex-cont">
              <div className="flex-start m-1">
                <h4 className="dash-head text-center">Admin's List</h4>
              </div>
              <div class="flex-end">
                <button
                  type="button"
                  className="btn btn-add"
                  onClick={() => navigate("/add-admin")}
                >
                  Add
                </button>
              </div>
            </div>
            <div className="card dash_table p-3">
              <table className="table tab-back dash_table table-hover p-3">
                <thead className="thead-light">
                  <tr>
                    <th>#</th>
                    <th>name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Notifications</th>
                    <th>Created At</th>
                    <th>Edit</th>
                    <th className="text-center">Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {admins.map((admin, index) => (
                    <tr key={admin._id}>
                      <th scope="row">{index + 1}</th>
                      <td>{admin?.name ?? "Admin"}</td>
                      <td>{admin.email}</td>
                      <td>{admin.role}</td>
                      <td>
                        <Popconfirm
                          description="Are you sure you want to change the notification settings for this admin?"
                          okText="Yes"
                          cancelText="No"
                          icon={
                            <Pi.PiWarningDuotone
                              className="fs-6 m-2"
                              color="#f44336"
                            />
                          }
                          okButtonProps={{ style: { background: "#f44336" } }}
                          onConfirm={() => handleConfirmChange(admin)}
                          disabled={
                            adminsLoading || admin.role === "superadmin"
                          }
                        >
                          <Switch
                            checked={admin.notifications}
                            disabled={
                              adminsLoading || admin.role === "superadmin"
                            }
                          />
                        </Popconfirm>
                      </td>
                      <td>{Utils.formatDate(admin?.createdAt)}</td>
                      <td>
                        <button
                          className="action_btn"
                          onClick={() => navigate(`/update-admin/${admin._id}`)}
                        >
                          <i>
                            <Ci.CiEdit />
                          </i>
                        </button>
                      </td>
                      <td className="text-center">
                        <button
                          className="action_btn text-center"
                          onClick={() => {
                            setAcknowledge(true);
                            setSelectedAdmin(admin._id);
                          }}
                        >
                          <i>
                            <Bs.BsTrash />
                          </i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Admins;
